import type { BucketCardProps } from 'bundles/front-page/components/modules/buckets/BucketCard';
import { getBucketTestV2Variant } from 'bundles/front-page/utils/showBucketTestV2';

import CareersBucketImage from 'images/front-page/Coursera-Careers-Bucket-v1.png';
import DegreesBucketImage from 'images/front-page/Coursera-Degrees-Bucket-v1.png';
import GenAIBucketImage from 'images/front-page/Coursera-GenAI-Bucket-v1.png';

import _t from 'i18n!nls/front-page';

export const getMockBucketData = (): BucketCardProps[] => {
  const variant = getBucketTestV2Variant();

  const launchANewCareer = {
    imageUrl: CareersBucketImage,
    title: _t('Launch a new career'),
    body: _t('Get flexible, online training designed to get you job-ready for high-growth fields. '),
    url: '/career-academy',
  };
  const buildInDemandSkills = {
    imageUrl: GenAIBucketImage,
    title: _t('Build in-demand AI skills'),
    body: _t(
      'Learn the fundamentals and grow your generative AI (GenAI) skill set with courses and certificates taught by experts.'
    ),
    url: '/explore/generative-ai',
  };

  const earnADegree = {
    imageUrl: DegreesBucketImage,
    title: _t('Earn a degree'),
    body: _t('Enroll in a flexible, 100% online degree program to start or advance your career.'),
    url: '/degrees',
  };

  const mostPopular = {
    imageUrl: CareersBucketImage,
    title: _t('Most popular'),
    body: _t('Enroll in a flexible, 100% online degree program to start or advance your career.'),
    url: '/career-academy',
  };

  if (variant === 'B') {
    return [launchANewCareer, buildInDemandSkills, earnADegree];
  }

  return [launchANewCareer, mostPopular, earnADegree];
};
